import React from "react";
import ReactDOM from "react-dom";
import {getShopId} from "../lib/getShopId";
import {useCustomerContext} from "../customer/CustomerContextProvider/CustomerContextProvider";
import ProductList from "./list/ProductList";

const ProductListPortal: React.FC = () => {
  const {customerId, customerGroupId, visitorId} = useCustomerContext().customer;
  const element = document.querySelector<HTMLDivElement>(".product-list-react > div");

  if (!element) {
    return null;
  }

  const preloader = element.getElementsByClassName("swiper-lazy-preloader")[0];
  if (preloader) element.removeChild(preloader);
  const br = element.getElementsByClassName("clear")[0];
  if (br) element.removeChild(br);

  return ReactDOM.createPortal(
    <ProductList
      shopId={getShopId()}
      categoryId={Number(document.body.id.substr(1))}
      currency={window.c_ActiveCurrency}
      {...{customerId, customerGroupId, visitorId}}
    />,
    element,
  );
};

export default ProductListPortal;
